import { AcceptPage } from '@/cms/definitions/content-types';
import { DigitalAcceptCmsPage, Policy } from '@/types/types';
import { flattenProductFields } from './FieldService';
import { POLICIES, POLICY_FIELDS } from '@/types/enums';

export const normalizeModelFromApi = (proposal: DigitalAcceptCmsPage, cmsModel: AcceptPage) => {
	for (const policy of proposal.policies) {
		flattenProductFields(policy);
		mapTypeAndTitle(policy, cmsModel);
		mapDescription(policy);
		productHacks(policy, cmsModel);
	}
};

export const mapTypeAndTitle = (policy: Policy, cmsModel: AcceptPage) => {
	const isAcceptPage = cmsModel.contentType === 'AcceptPage';
	const mappedProductType = getProductType(policy);

	if (isAcceptPage) {
		// accept page
		for (const policyRawBlock of cmsModel.adjustPoliciesBlock?.policyBlock?.items || []) {
			if (policyRawBlock.content.type.toLocaleLowerCase() === mappedProductType.toLocaleLowerCase()) {
				policyRawBlock.content.originalType = policy.type;
				policy.type = mappedProductType;
				policy.title = policyRawBlock.content.title;
				break;
			}
		}
	} else {
		// receipt page
		for (const policyBlock of cmsModel?.productNames || []) {
			if (policyBlock.key.toLocaleLowerCase() === mappedProductType.toLocaleLowerCase()) {
				policy.title = policyBlock.value;
				break;
			}
		}
	}

	mapAccidentTitle(policy);
};

const getProductType = (policy: Policy): string => {
	let policyType = policy.type;
	if (policy.type.startsWith(POLICIES.CONTENT)) {
		policyType = POLICIES.CONTENT;
	}
	if (policy.type.endsWith(POLICIES.MOPED)) {
		policyType = POLICIES.MOPED;
	}
	return policyType;
};

const mapAccidentTitle = (policy: Policy) => {
	if (policy.type === POLICIES.ACCIDENT) {
		switch (policy?.policy_object?.accident_insurance_type) {
			case 'ADULT':
				policy.title = 'Voksenulykke';
				break;
			case 'CHILD':
				policy.title = 'Børneulykke';
				break;
			case 'EXTENDED_REPLACEMENT':
				policy.title = 'Udvidet strakserstatning';
				break;
			case 'ASSAULT':
				policy.title = 'Overfald';
				break;
			default:
				break;
		}
	}
};

export const mapDescription = (policy) => {
	// job_title -> accident
	// brand -> trailer
	// coverage_area -> travel 'EUROPE' | 'WORLD*

	switch (policy.type) {
		case POLICIES.ACCIDENT:
			policy.description = policy.policy_object?.name;
			// TO BE -> policy.description = policy.policy_object?.job_title;
			break;
		case POLICIES.TRAVEL:
			if (policy.policy_object?.coverage_area === 'EUROPE') {
				policy.description = 'Dækker Europa';
			} else if (policy.policy_object?.coverage_area === 'WORLD') {
				policy.description = 'Dækker Verden';
			}
			break;
		case POLICIES.CAR:
		case POLICIES.TRAILER:
			policy.description = policy.policy_object?.brand;
			break;
	}
};

const productHacks = (policy: Policy, cmsModel: AcceptPage) => {
	switch (policy.type) {
		case POLICIES.HOUSE:
		case POLICIES.HOLIDAY_HOUSE:
			if (policy?.policy_object?.hasOwnProperty(POLICY_FIELDS.previous_policy_id)) {
				policy.policy_object[POLICY_FIELDS.customer_owns_house] = 'N';
			}
			break;
		default:
			break;
	}
};
